export const VOUCHERS_BUY_DEALER = 'VOUCHERS::VOUCHERS_BUY_DEALER';